export const selectSocketWorks = (state) => state.appReducer.sockets.socketWorks || ''
